<template>
  <div>
    <div class="content">
      <transition name="transition" appear mode="out-in">
        <a-space direction="vertical" :size="40">
          <j-empty />
          <a-card class="detail form" title="Solicitud">
            <j-form :posting="posting" @submit="onSubmit" />
          </a-card>
          <j-footer />
        </a-space>
      </transition>
    </div>
  </div>
</template>

<script>
import JFooter from '@/components/footer'
import JEmpty from '@/components/empty'
import JForm from '@/components/form'
export default {
  name: 'SignUp',
  components: {
    JFooter,
    JEmpty,
    JForm,
  },
  data() {
    return {
      posting: false,
    };
  },
  methods: {
    onSubmit(payload) {
      this.posting = true
      this.$http.post('couriers', payload)
      .then(() => this.$router.push('/success'))
      .catch(error => {
        if (error.response && error.response.data && error.response.data.code === 'ALREADY_EXISTS') {
          this.$router.push('success')
        } else {
          this.$router.push('failure')
        }
      })
      .finally(() => (this.posting = false))
    },
  },
}
</script>
<style scoped>
.loader {
  padding: 30px;
}
.content {
  max-width: 1000px;
  margin: auto;
}
.detail {
  max-width: 800px;
  margin: auto;
}
.form {
  padding: 10px;
}
.support {
  margin-left: -41px;
}
.support button{
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
.transition-enter-active, .transition-leave-active {
  transition: opacity .8s, transform .8s;
}
.transition-enter {
  opacity: 0;
  transform: translateY(20px)
}
.transition-leave-to {
  opacity: 0;
  transform: translateY(-20px)
}
</style>